<template>
  <div class='termsPage' id='termsPage' ref='termsPage'>
    <TopBack :title="$t('lang.common.Terms')"/>
    <div class="termsBox">
      <div class="lasttime">Last updated: 1 Sep 2026</div>
      <div class="paragraph" v-for="(paragraph, index) in $t('lang.terms.paragraph')" :key="index">
        <div class="title">{{ $t('lang.terms.title')[index] }}</div>
        <div class="text" v-html="getMail(paragraph)"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapMutations} from 'vuex'
import TopBack from '@/components/TopBack/index'

export default {
  name: 'Terms',
  components: {
    TopBack
  },
  data () {
    return {
      supportMail: 'legal@databox.ai'
    }
  },
  watch: {},
  async mounted () {
  },
  beforeDestroy () {
  },
  methods: {
    ...mapMutations({
      setCurrentRoute: 'setCurrentRoute',
      setInternationName: 'setInternationName',
      setInternation: 'setInternation'
    }),
    getMail (paragraph) {
      return paragraph.replace('{supportMail}', `<span style="color:var(--footerAct)">` + this.supportMail + `</span>`)
    }
  }
}
</script>

<style lang='less' scoped>
.termsPage {
  height: 100dvh;
  overflow: auto;
  position: relative;
  overflow-x: hidden;
  padding-bottom: 5vw;
  background: var(--background);
  padding-top: calc(60vw / 3.6);

  .termsBox {
    position: relative;
    margin-top: calc(12vw / 3.6);
    left: 50%;
    transform: translate(-50%);
    box-sizing: border-box;
    padding: calc(24vw / 3.6) calc(20vw / 3.6);
    width: calc(328vw / 3.6);
    height: max-content;
    background: #FFFFFF;
    border: calc(1vw / 3.6) solid rgba(195, 197, 216, 0.3);
    box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.04);
    border-radius: calc(12vw / 3.6);

    .lasttime {
      font-family: 'Hanken Grotesk';
      font-weight: 500;
      font-size: calc(12vw / 3.6);
      letter-spacing: 0.01em;
      color: #575E69;
    }

    .paragraph {
      margin: calc(23vw / 3.6) 0;
      height: max-content;

      .title {
        font-family: 'Hanken Grotesk';
        font-style: normal;
        font-weight: 600;
        font-size: calc(14vw / 3.6);
        line-height: calc(20vw / 3.6);
        color: var(--blackFont);
      }

      .text {
        margin-top: calc(6vw / 3.6);
        font-family: 'Hanken Grotesk';
        font-weight: 400;
        font-size: calc(14vw / 3.6);
        line-height: calc(23vw / 3.6);
        color: var(--footer);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Terms/index.vue